module.exports = {
  "1": "en",
  "2": "es",
  "3": "pt",
  "4": "ru",
  "5": "fr",
  "6": "de",
  "7": "cn",
  "8": "tw",
  "9": "jp"
};
